import React from "react";

import { Row, Col, Statistic } from "antd";
import moment from "moment";

// Styles
import { FigureInfomationWrapper } from "./styles";

//import multilanguage library
import { useTranslation } from "react-i18next";

import { grades } from "../../constants";

const RenderFigureData = ({ selectedArticle }) => {
  //To translate text
  const { t } = useTranslation();

  const figureEntries = selectedArticle && selectedArticle.figure && Object.entries(selectedArticle.figure.values);

  const gradeText = (selGrade) => grades.find((grade) => grade.value === selGrade) && grades.find((grade) => grade.value === selGrade).name;

  if (!selectedArticle) return null;
  return (
    <FigureInfomationWrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col span={8} key="figure">
          <Statistic title={t("labels.figure")} value={selectedArticle && t("geometry." + selectedArticle.figure.name)} suffix="" />
        </Col>
        <Col span={16} key="date">
          <Statistic
            title={t("labels.article_date")}
            value={selectedArticle && selectedArticle.date && moment(selectedArticle.date).format("DD/MM/YYYY HH:mm:ss")}
            suffix=""
          />
        </Col>
        <Col span={8} key="grado_acero">
          <Statistic title={t("labels.steel_grade")} value={gradeText(selectedArticle.grade)} suffix="" precision={0} />
        </Col>
        <Col span={8} key="capa_dura">
          <Statistic title={t("labels.hard_coat")} value={selectedArticle && selectedArticle.hard_coat} suffix=" mm" />
        </Col>
        <Col span={8} key="dureza">
          <Statistic
            title={t("labels.hardness_required")}
            value={selectedArticle && selectedArticle.hardness_required}
            formatter={(value) => value && value.toString().replace(",", "")}
            suffix=" HV1"
          />
        </Col>
        {selectedArticle &&
          figureEntries &&
          figureEntries.map(([key, value], index) => (
            <Col span={8} key={index}>
              <Statistic
                title={t("labels.measurements." + key)}
                value={value}
                precision={0}
                suffix=" mm"
                formatter={(value) => value && value.toString().replace(",", "")}
              />
            </Col>
          ))}
      </Row>
    </FigureInfomationWrapper>
  );
};

export default RenderFigureData;
